import { FC } from "react";
import { useTranslation } from "react-i18next";
import { AdminFormFieldCheckbox } from "../../../../components/admin/formFields";

interface NotifocationAndViolationProps {
  values: any;
  errors: any;
  touched: any;
  handleChange: (event: React.ChangeEvent<any>) => void;
  setFieldValue: (field: string, value: any) => void;
  handleBlur: (event: React.FocusEvent<any>) => void;
  setFieldTouched: (field: string, isTouched: boolean) => void;
  selectedField: string;
}

const NotifocationAndViolation: FC<NotifocationAndViolationProps> = ({
  values,
  errors,
  touched,
  handleChange,
  setFieldValue,
  handleBlur,
  setFieldTouched,
  selectedField,
}) => {
  const { t } = useTranslation("translation", {
    keyPrefix: "camera.dashboard.management.traffic_signal_detection",
  });
  const eventKey = selectedField?.replace(/Enable$/, "");

  const audioPreWarning = `${eventKey}_audioPreWarning`;

  return (
    <div className="col-span-6 p-6 space-y-1">
      <div className="w-full space-y-2 mb-4">
        <h1 className="text-lg text-accent-blue-dark font-bold mb-4">
          {t(selectedField)}
        </h1>
        <h2 className="block font-semibold text-sm leading-none tracking-normal">
          {t("in_cabin_audio_alert")}
        </h2>
        <p className="font-normal text-sm leading-none mb-4 text-gray-500">
          {t("in_cabin_audio_alert_description")}
        </p>
      </div>
      <div className="col-span-6 grid grid-cols-6 space-x-2">
        <AdminFormFieldCheckbox
          customWrapperClass="col-span-3"
          label={t("approaching_the_traffic_and_signal")}
          id={audioPreWarning}
          type="checkbox"
          name={audioPreWarning}
          checked={values[audioPreWarning]}
          onChange={handleChange}
          onBlur={handleBlur}
          error={errors[audioPreWarning]}
          touched={touched[audioPreWarning]}
        />
      </div>
    </div>
  );
};

export default NotifocationAndViolation;
